// hooks/useTabManager.ts
import { useState, useEffect, useRef } from "react";

interface UseTabManagerReturn {
  isActive: boolean;
  activateTab: () => void;
}

function generateSecureCode(length = 9) {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const array = new Uint32Array(length);
  crypto.getRandomValues(array);

  return Array.from(array, x => chars[x % chars.length]).join("");
}

export const useTabManager = (): UseTabManagerReturn => {
  const [isActive, setIsActive] = useState<boolean>(true);
  const tabIdRef = useRef<string>(`tab_${generateSecureCode()}`);

  const activateTab = (): void => {
    localStorage.setItem("activeTab", tabIdRef.current);
    sessionStorage.setItem("isActiveTab", tabIdRef.current);
    setIsActive(true);
  };

  useEffect(() => {
    activateTab();

    document.addEventListener("visibilitychange", () => {
      const activeTab = localStorage.getItem("activeTab");
      const isActiveTab = sessionStorage.getItem("isActiveTab");
      if (!document.hidden) {
        if (activeTab && activeTab !== isActiveTab) {
          setIsActive(false);
        }
      }
    });
  }, []);

  return {
    activateTab,
    isActive
  };
};
